import { api } from "../api";

export const exportCareTemplate = async (careTemplateId: string): Promise<string> => {
  const result = await api.services.careTemplates.exportCareTemplate(careTemplateId);
  return JSON.stringify(result.data);
};
